interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ArrowDownIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M7.45625 14.7688C7.59687 14.9156 7.79375 15 8 15C8.20625 15 8.4 14.9156 8.54375 14.7688L13.7937 9.26875C14.0813 8.96875 14.0688 8.49375 13.7688 8.20938C13.4688 7.925 12.9938 7.93437 12.7094 8.23438L8.75 12.3781V1.75C8.75 1.33437 8.41562 1 8 1C7.58437 1 7.25 1.33437 7.25 1.75V12.3781L3.29375 8.23125C3.00625 7.93125 2.53437 7.92188 2.23437 8.20625C1.93437 8.49063 1.925 8.96562 2.20937 9.26562L7.45937 14.7656L7.45625 14.7688Z" />
    </svg>
  );
}
